<template>

  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h1 class="brand-text text-primary ml-1">
          Archistar
        </h1>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <!-- <b-col class="d-none d-lg-flex align-items-center p-5" lg="8">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img :src="imgUrl" alt="Login V2" fluid />
        </div>
      </b-col> -->
      <!-- /Left Text-->
      <!-- Login-->
      <b-col class="d-flex align-items-center auth-bg">

        <b-col
          class="px-xl-2 mx-auto"
          lg="8"
          md="8"
          sm="8"
        >
          <b-card-title
            class="font-weight-bold mb-1"
            title-tag="h2"
          >
            Benvenuto/a su Archistar! 👋
          </b-card-title>
          <!-- <b-card-text class="mb-2">
            Please sign-in to your account and start the adventure
          </b-card-text> -->

          <h4
            v-show="validationError"
            style="color: #ea5455"
          >
            Tentativo di Login Fallito!
          </h4>
          <!-- form -->
          <validation-observer
            ref="loginValidation"
            v-slot="{ invalid }"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                size="lg"
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  ref="email-validator"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    size="lg"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link :to="{ name: 'forgot' }">
                    <small>Reimposta Password</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  ref="password-validator"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    class="input-group-merge"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      size="lg"
                      :state="errors.length > 0 ? false : null "
                      :type="passwordFieldType"
                      class="form-control-merge"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!--              <b-form-group>-->
              <!--                <b-form-checkbox-->
              <!--                  id="remember-me"-->
              <!--                  v-model="status"-->
              <!--                  name="checkbox-1"-->
              <!--                >-->
              <!--                  Ricordami-->
              <!--                </b-form-checkbox>-->
              <!--              </b-form-group>-->

              <!-- submit buttons -->
              <b-button
                class="mt-2"
                type="submit"
                variant="primary"

                @click="login"
              >
                <span v-show="!loadingShow"> Accedi  </span>
                <b-spinner
                  v-show="loadingShow"
                  label="Attendi..."
                />
              </b-button>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{ name: 'page-auth-register-v2' }">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">or</div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button href="javascript:void(0)" variant="facebook">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button href="javascript:void(0)" variant="twitter">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button href="javascript:void(0)" variant="google">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button href="javascript:void(0)" variant="github">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import authRepository from '@/api/authRepository'
import authStore from '@/services/authStore'
// import tenantRepository from "@/api/tenantRepository";

export default {
  components: {
    BSpinner,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardTitle,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  setup() {
    const { token, currentUser, userType } = authStore()
    return {
      token,
      currentUser,
      userType,
    }
  },
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      loadingShow: false,
      // validation rulesimport store from '@/store/index'
      required,
      email,
      validationError: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    async login() {
      localStorage.clear()
      const acl = await this.validationForm()
      if (acl) {
        // this.setAcl(acl)
        await this.$router.push('/files')
      }
    },
    async validationForm() {
      this.validationError = false
      this.loadingShow = true
      try {
        const { data } = await authRepository.login({
          email: this.userEmail,
          password: this.password,
        })

        if (data.code) {
          console.log('ciao')
          store.commit('auth/UPDATE_CURRENT_USER_TOKEN', { token: `Bearer ${data.data.token}` })
          store.commit('auth/UPDATE_CURRENT_USER', { currentUser: data.data.name })
          store.commit('auth/UPDATE_USER_TYPE', {
            userType: data.data.profile,
          })
          store.commit('auth/SET_ACL', { acl: data.data.acl })
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Login avvenuto con successo!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        }, {
          position: 'top-center',
        })
        const aclObj = []
        Object.keys(data.data.acl).forEach(key => {
          aclObj.push({
            action: data.data.acl[key],
            subject: 'object',
          })
        })
        this.$ability.update(aclObj)
        return true
      } catch (error) {
        console.log(error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Tentativo di Login Fallito!',
            icon: 'XIcon',
            variant: 'danger',
          },
        }, {
          position: 'top-center',
        })

        this.$refs['email-validator'].applyResult({
          errors: ['Email o Password non corretti'],
          valid: false,
          failedRules: {},
        })

        this.$refs['password-validator'].applyResult({
          errors: ['Email o Password non corretti'],
          valid: false,
          failedRules: {},
        })
        this.validationError = true
      }
      this.loadingShow = false
      return false
    },
    setAcl(acl) {
      const aclObj = []
      Object.keys(acl).forEach(key => {
        aclObj.push({
          action: acl[key],
          subject: 'object',
        })
      })

      localStorage.setItem('acl', JSON.stringify(aclObj))
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
